module.exports = __webpack_public_path__ + "img/tip_icon.3731ceb6.png";